import { useNetworkState } from "@shared/hooks/useNetworkState";
import { ReactNode, useEffect, useRef } from "react";
import NotFoundPage from "./NotFoundPage";

interface NetworkGuardProps {
  children?: ReactNode;
}

/**
 * NetworkGuard component that checks if the user is online
 * If offline, displays the NotFoundPage with network error message
 * When network comes back up, refreshes the page
 * Otherwise renders the children components
 */
const NetworkGuard = ({ children }: NetworkGuardProps) => {
  const isOnline = useNetworkState();
  const wasOffline = useRef(false);

  useEffect(() => {
    // If we were offline and now we're online, refresh the page, keeping it if necessary in future
    /* if (wasOffline.current && isOnline) {
      window.location.reload();
    } */

    // Track offline state
    if (!isOnline) {
      wasOffline.current = true;
    }
  }, [isOnline]);

  if (!isOnline) {
    return (
      <NotFoundPage
        title="Check your network connection"
        description="Please ensure you are connected to the internet and try again."
      />
    );
  }

  return <>{children}</>;
};

export default NetworkGuard;
